import { create } from "zustand";
import { loadAnalytics, revokeAnalytics } from "@app/gtag.ts";

export type ConsentValue = "granted" | "denied";

const STORAGE_KEY = "gf-consent";
// Subir la versión invalida las decisiones previas (por ejemplo, al añadir una
// finalidad nueva): el banner vuelve a pedir el consentimiento.
const VERSION = 1;

function read(): ConsentValue | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as { v?: number; value?: string };
    if (parsed.v === VERSION && (parsed.value === "granted" || parsed.value === "denied")) {
      return parsed.value;
    }
  } catch {
    /* almacenamiento no disponible o valor corrupto */
  }
  return null;
}

function save(value: ConsentValue): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ v: VERSION, value, ts: Date.now() }));
  } catch {
    /* ignorar */
  }
}

interface ConsentState {
  /** Decisión del jugador; null mientras no ha elegido. */
  value: ConsentValue | null;
  /** Fuerza mostrar el banner para cambiar la elección. */
  open: boolean;
  decide: (value: ConsentValue) => void;
  reopen: () => void;
}

export const useConsent = create<ConsentState>((set) => ({
  value: null,
  open: false,
  decide: (value) => {
    save(value);
    if (value === "granted") loadAnalytics();
    else revokeAnalytics();
    set({ value, open: false });
  },
  reopen: () => set({ open: true }),
}));

/** Carga la decisión guardada y arranca la analítica si se aceptó. */
export function initConsent(): void {
  // En modo captura nunca se carga analítica.
  if (__CAPTURE__) return;
  const value = read();
  useConsent.setState({ value, open: value === null });
  if (value === "granted") loadAnalytics();
}
